export default __webpack_public_path__ + "static/no_notif-3abc786e629f30e877e4e2ae1dc08d48.svg";